import { createContext, useContext, useEffect, useState } from 'react';
import { get } from 'api';
import { useAuth } from './auth-provider/AuthJwtProvider';

console.log('🔥 notificationContext FILE LOADED:');
const NotificationContext = createContext({
  notifications: [], // ✅ DEFAULT VALUE FIX
  setNotifications: () => {},
  addNotification: () => {},
});

export const NotificationProvider = ({ children }) => {
  const { sessionUser } = useAuth();
  const [notifications, setNotifications] = useState([]);
  const addNotification = (notif) => {
    setNotifications((prev) => [notif, ...prev]);
  };

  const clearNotifications = () => {
    setNotifications([]);
  };

  const fetchNotification = async () => {
    try {
      const res = await get('users/getNotification');
      if (res.status === 200) {
        setNotifications(res.data);
      }
    } catch (error) {
      console.log('error', error);
      setNotifications([]);
    }
  };
  useEffect(() => {
    fetchNotification();
  }, [sessionUser?._id]);

  return (
    <NotificationContext.Provider
      value={{
        notifications,
        setNotifications,
        addNotification,
        clearNotifications,
        fetchNotification,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => useContext(NotificationContext);
